module.exports = __webpack_public_path__ + "static/231_Balceta_Ct-2ea7bd8621a6d7bd5b29d3f72aed1fba.webp";